module.exports = __webpack_public_path__ + "static/media/ML.1aaca6ca.svg";